import { AgentStatusSelect, BrokerTeamSelect } from '@insurance/components'
import { useQueryUpdate } from '@shared/hooks'
import { Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export const AgentsFilters = () => {
  const { params, updateQuery } = useQueryUpdate()
  const { id } = useParams()
  const { t } = useTranslation()

  return (
    <Space wrap>
      <AgentStatusSelect
        value={params.status}
        onChange={(status) => updateQuery({ status })}
      />

      <BrokerTeamSelect
        value={params.teams}
        className="select-min-width"
        broker={id}
        maxTagCount={1}
        placeholder={t('teams')}
        maxTagTextLength={6}
        onChange={(teams) => updateQuery({ teams })}
        mode="multiple"
      />
    </Space>
  )
}
